// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__yRqxg","container":"styles_container__ul6fc","light":"styles_light__c_6lp"};